export function isFileSizeValid(size: number, limit: number) {
	return size / 1024 ** 2 < limit;
}
